import NotFound from "../../../components/notfound/NotFound";
import {Box, Card, CardContent, Skeleton, Typography} from "@mui/material";
import {COLORS} from "../../../ui/Theme";
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {CustomTooltip} from "./historyCustomTooltip";

const HistoryVolumeChart = ({data}) => {

    return (
        <Card
            sx={{
                border: "1px solid",
                borderColor: COLORS.SOFTGRAY,
                padding: 0,
                minHeight: 500,
            }}
        >
            <CardContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    alignItems: "center",
                }}
            >
                <Typography
                    sx={{
                        fontSize: "20px",
                        fontWeight: 700,
                        color: COLORS.BLACK,
                        textAlign: "center",
                        padding: "20px"
                    }}>
                    تاریخچه حجم نماد
                </Typography>
                {
                    !data?.data?.length ? (
                        <Box>
                            <NotFound/>
                        </Box>
                    ) : (
                        data?.isLoading ? (
                            <Skeleton
                                sx={{
                                    borderRadius: "12px"
                                }}
                                variant="rounded"
                                width="100%"
                                height="500px"
                            />
                        ) : (
                            <>
                                <ResponsiveContainer width="100%" height={500}>
                                    <LineChart
                                        data={data?.data}
                                        syncId="history"
                                        margin={{top: 0, right: 0, bottom: 20, left: 0}}
                                    >
                                        <CartesianGrid strokeDasharray="0 0" stroke={COLORS.SOFTGRAY}/>
                                        <XAxis
                                            dataKey="date"
                                            stroke={COLORS.GRAY}
                                            tickMargin={10}
                                            angle={-10}
                                        />
                                        <YAxis
                                            textAnchor="start"
                                            tickMargin={10}
                                            stroke={COLORS.GRAY}
                                            domain={["auto", "auto"]}
                                        />
                                        <Legend
                                            verticalAlign="top"
                                            wrapperStyle={{
                                                width: "fit-content",
                                                top: -10,
                                                right: 0,
                                                lineHeight: "20px",
                                            }}
                                            formatter={(value) => {
                                                if (value === "volume") {
                                                    return <span style={{marginRight: "5px"}}>حجم (میلیون)</span>;
                                                }
                                                return value;
                                            }}
                                        />
                                        <Tooltip cursor={{ fill: COLORS.SOFTGRAY }} content={<CustomTooltip keysToShow={["volume"]}/>}/>
                                        <Line
                                            dataKey="volume"
                                            connectNulls
                                            type="monotone"
                                            stroke={COLORS.BLUE}
                                            dot={false}
                                            strokeWidth={2}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </>
                        )
                    )
                }
            </CardContent>
        </Card>
    );
};

export default HistoryVolumeChart;